import { Typography, TypographyProps } from '@mui/material';
import * as main from '@shared/styles/abstracts/vars.module.scss';

export const CountOfSelected = (props: Omit<TypographyProps, 'children'> & { count: number }) => {
  const { count, ...rest } = props;
  return count ? (
    <Typography
      sx={{
        fontSize: main.fontSmall,
        lineHeight: '18px',
        fontWeight: 400,
        color: main.colorActive,
      }}
      {...rest}
    >
      {count}
    </Typography>
  ) : null;
};

export const getSelectedCount = (param: string) => {
  const splitedParam = param.split(',');
  if (JSON.stringify(splitedParam) === JSON.stringify([''])) {
    return 0;
  } else {
    return splitedParam.length;
  }
};
